import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppLayout } from "../components/AppLayout";
import { HomePage } from "../pages/HomePage";
import { LegalPage } from "../pages/LegalPage";

const CreatePage = lazy(() => import("../pages/CreatePage"));
const PreviewPage = lazy(() => import("../pages/PreviewPage"));
const ReaderPage = lazy(() => import("../pages/ReaderPage"));
const SentPage = lazy(() => import("../pages/SentPage"));

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route
            path="create/:draftId?"
            element={
              <RouteLoader>
                <CreatePage />
              </RouteLoader>
            }
          />
          <Route
            path="preview/:draftId"
            element={
              <RouteLoader>
                <PreviewPage />
              </RouteLoader>
            }
          />
          <Route
            path="l/:letterId"
            element={
              <RouteLoader>
                <ReaderPage />
              </RouteLoader>
            }
          />
          <Route
            path="sent/:letterId"
            element={
              <RouteLoader>
                <SentPage />
              </RouteLoader>
            }
          />
          <Route path="privacy" element={<LegalPage kind="privacy" />} />
          <Route path="terms" element={<LegalPage kind="terms" />} />
          <Route path="*" element={<LegalPage kind="not-found" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function RouteLoader({ children }: { children: React.ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="route-loader" role="status">
          Preparing your paper…
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
